<template>
	<div class="container-wrap">
		<div class="container">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{path:'/productHome'}">首页</el-breadcrumb-item>
			  <el-breadcrumb-item>搜索结果</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="main">
				<div class="content">
					<div class="search-wrap">
						<el-input v-model="keyWords" @change="getDataList"/>
						<span class="search-btn" @click="getDataList">搜索</span>
					</div>
					<el-tabs class="tabs" v-model="activeTab" @tab-click="handleClick">
					    <el-tab-pane label="全部" name="all">
							<div class="search-result">
								<div class="search-num">共搜索到{{total}}条结果</div>
								<SearchAll @toDetail="toDetailAll" :list="dataList"/>
							</div>
						</el-tab-pane>
					    <el-tab-pane label="新闻" name="news">
							<div class="search-result">
								<div class="search-num">共搜索到{{total}}条结果</div>
								<SearchList @toDetail="toDetailNew" :list="dataList"/>
							</div>
						</el-tab-pane>
					    <el-tab-pane label="视频" name="video">
							<div class="search-result">
								<div class="search-num">共搜索到{{total}}条结果</div>
								<SearchList @toDetail="toDetailNew" :list="dataList"/>
							</div>
						</el-tab-pane>
					    <el-tab-pane label="下载" name="download">
							<div class="search-result">
								<div class="search-num">共搜索到{{total}}条结果</div>
								<SearchDown :list="dataList"/>
							</div>
						</el-tab-pane>
						<el-tab-pane label="文档" name="document">
							<div class="search-result">
								<div class="search-num">共搜索到{{total}}条结果</div>
								<SearchDocument @toDetail="toDetailNew" :list="dataList"/>
							</div>
						</el-tab-pane>
					  </el-tabs>
					  <div class="pagination-wrap" v-if="total>0">
					  	<el-pagination
					  	  background
					  	  layout="prev, pager, next"
					  	  :page-size= this.pageSize
					  	  :total=this.total
					  	  @current-change="handleCurrentChange"
						  :current-page = "pageNum"
					  	  >
					  	</el-pagination>
					  </div>
				</div>
				<div class="main-right">
					<Recommend @toDetail="toDetailRecommend" :list="recommendList" :imgList="recommendImg"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Recommend from '@/components/product/recommend'
	import SearchList from '@/components/product/search/searchList'
	import SearchDown from '@/components/product/search/searchDown'
	import SearchAll from '@/components/product/search/searchAll'
	import SearchDocument from '@/components/product/search/searchDocument'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import recommendImg from '@/modules/product/recommendImg.js'
	export default {
		name: 'Search',
		components: {
			Recommend,
			SearchList,
			SearchDown,
			SearchAll,
			SearchDocument
		},
		mixins: [
			recommendImg
		],
		data() {
			return {
				activeTab: 'all',
				keyWords:  '',
				recommendList: [],
				pageNum: 1,
				pageSize: 6,
				currentPage: 1,
				dataList: [],
				total: 0,
				searchType: ''  //不传，或者传空为全部 news：新闻 video：视频 download：下载 document：文档
			}
		},
		created(){
			let keyWords = this.$route.query.keyWords
			this.keyWords = keyWords
			this.getRecommendList()
			this.getRecommendImg()
			this.getDataList()
		},
		watch: {
			$route(to, from){
				let keyWords = this.$route.query.keyWords
				this.keyWords = keyWords
				this.getRecommendList()
				this.getDataList()
			}
		},
		methods: {
			toDetailAll(e){
				if(e.linkCode=='download') {
					window.location.href = e.linkRoute
				} else {
					this.$router.push({
						path: e.linkRoute
					})
				}
			},
			toDetailNew(e){
				this.$router.push({
					path: e.linkRoute
				})
			},
			//获取搜索列表数据
			async getDataList(){
				let param = {
					searchKeyWord: this.keyWords,
					searchType: this.searchType,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				const res = await post('v1/column/getSearchData', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取搜索推荐
			async getRecommendList(){
				let param = {
					searchKeyWord: this.keyWords,
					pageSize: this.pageSize
				}
				const res = await post('v1/column/getSearchRecommend', qs.stringify(param))
				if(res.data.code==200){
					this.recommendList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toDetailRecommend(e){
				this.$router.push({
					path: e.linkRoute
				})
			},
			handleClick(tab, event) {
				this.searchType = tab.name
				if(this.searchType=='all'){
					this.searchType = ''
				}
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e
				this.getDataList()
			},
		}
	}
</script>

<style scoped lang="less">
	.container{
		padding-top: 26px;
		padding-bottom: 26px;
		.main{
			margin-top: 26px;
			display: flex;
			justify-content: space-between;
			.content{
				width: 780px;
				background: #fff;
				border-radius: 5px;
				padding: 10px 0;
				box-sizing: border-box;
				.search-wrap{
					display: flex;
					justify-content: space-between;
					padding: 0 24px;
				}
				.search-btn{
					width: 110px;
					height: 40px;
					background: #DE0515;;
					border-radius: 5px;
					margin-left: 10px;
					letter-spacing: 1.78px;
					color: #fff;
					font-size: 16px;
					text-align: center;
					line-height: 40px;
					cursor: pointer;
				}
				.tabs{
					padding: 0 24px;
				}
				.search-num{
					padding-left: 10px
				}
				.activeTab{
					
				}
				/deep/ .el-tabs__nav-wrap::after{
					height: 1px;
				}
				/deep/ .el-tabs__active-bar{
					background-color: #DE0515;
				}
				/deep/ .el-tabs__item.is-active{
					color: #DE0515;
				}
				/deep/ .el-input__inner:focus{
					border-color: rgba(222, 5, 21, 1)
				}
			}
		}
	}
</style>
